import { render, staticRenderFns } from "./UploadFarmsDetail.vue?vue&type=template&id=540b5f11&scoped=true"
import script from "./UploadFarmsDetail.vue?vue&type=script&lang=js"
export * from "./UploadFarmsDetail.vue?vue&type=script&lang=js"
import style0 from "./UploadFarmsDetail.vue?vue&type=style&index=0&id=540b5f11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540b5f11",
  null
  
)

export default component.exports